import { z } from 'zod';

export const BaseChangeLog = z.object({
  id: z.number(),
  editor: z.string(),
  edited_field: z.string(),
  label: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  detail: z.string(),
});

export type BaseChangeLog = z.infer<typeof BaseChangeLog>;
